module.exports = __webpack_public_path__ + "img/arrow-left.441ca32.svg";